import React from 'react';
import css from './Study.module.scss';
import ENISo from '../../assets/images/extra/ENISo.png';
import IPEIM from '../../assets/images/extra/IPEIM.png';
import IbnSina from '../../assets/images/extra/IbnSina.png';
// import great_power from '../../assets/images/chibi_anime/great_power.png';
import FooterWhiteMask from "../../assets/images/extra/footer-white-mask.png";

const links = [
    "https://www.google.com/maps/uv?pb=!1s0x12fd8aeb930217f1:0x26a65273b05b6eff!3m1!7e115!4shttps://lh5.googleusercontent.com/p/AF1QipMGQFZN5_vtyNbDO__3AFoNYCb9C1xtgMw50DYH%3Dw234-h176-k-no!5seniso+-+Google+Search!15zQ2dJZ0FRPT0&imagekey=!1e10!2sAF1QipMGQFZN5_vtyNbDO__3AFoNYCb9C1xtgMw50DYH&hl=en&sa=X&ved=2ahUKEwiw5KqA8fHtAhUURhUIHTGOD2UQoiowFnoECCQQAw",
    'https://www.google.com/maps/uv?pb=!1s0x130212a8e59c419b%3A0xb74332538103a08a!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipPWfrtx_J2ZKn8dUnjNNB8ShaHrEW3638PVVmkW%3Dw264-h176-k-no!5sipeim%20-%20Google%20Search!15zQ2dJZ0FRPT0&imagekey=!1e10!2sAF1QipPojKE9TUAC1AAsCBVfWqcNy1gcS-3bQXcGQ_ti&hl=en&sa=X&ved=2ahUKEwj0o9Xc5vHtAhWSQhUIHXDzBE8QoiowCnoECBcQAw',
    'https://www.google.com/maps/uv?pb=!1s0x12fdf5ba05a272cf:0x45e151c748a877e9!3m1!7e115!4shttps://lh5.googleusercontent.com/p/AF1QipPDPRh7YunJ4TU59v07hYa8VnPFTt0K_UOEs1fI%3Dw312-h176-k-no!5slyc%C3%A9e+ibn+sina+msaken+-+Google+Search!15zQ2dJZ0FRPT0&imagekey=!1e10!2sAF1QipPDPRh7YunJ4TU59v07hYa8VnPFTt0K_UOEs1fI&hl=en&sa=X&ved=2ahUKEwjGjOLo6fHtAhWHZxUIHXNdCQkQoiowFXoECB0QAw&cshid=1609198076654502'
]
const data = [
    {
        title: <h4>National School of Engineers in Sousse
            (<a href={links[0]} className={css.link} target='_blank' rel="noopener noreferrer">ENISo</a>)</h4>,
        description: <div><p>Graduated mid 2019 as a software engineer.</p><p>Applied Computing, Distributed System Specialization.</p>
        </div>,
        img: ENISo
    }, {
        title: <h4>Preparatory Institute Of Engineering Studies Of Monastir
            (<a href={links[1]} className={css.link} target='_blank' rel="noopener noreferrer">IPEIM</a>)</h4>,
        description: <div><p>Graduated mid 2016, after passing the national engineering school contest.</p>
            <p>Maths-Physics Specialization.</p></div>,
        img: IPEIM
    }, {
        title: <h4><a href={links[2]} className={css.link} target='_blank' rel="noopener noreferrer">High School Ibn
            Sina</a></h4>,
        description: <div><p>Graduated mid 2013.</p> <p>Mathematics Specialization.</p></div>,
        img: IbnSina
    },
]
const Study: React.FC = () => (
    <div className={css.Study} id='study'>
        <img className={css.FooterWhiteMask} src={FooterWhiteMask} alt=''/>

        <h1 className={css.title}>Education</h1>
        <div className={css.bar}/>
        <div className={css.heroContainer}>
            {/*<img className={css.heroImg} src={great_power} alt=""/>*/}
            <div className={css.HeroInstitutions}>
                {
                    data.map((d, index) =>
                        <div key={index} className={css.HeroInstitution}>
                            <img src={d.img} className={css.imgInstitution} alt=""/>
                            <div>
                                {d.title}
                                {d.description}
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    </div>
);

export default Study;
